"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'BroadcastProDetail',
  data: function data() {
    return {
      dialogVisible: false,
      isEdit: false,
      option: {
        form: {
          labelWidth: '150px'
        }
      },
      FormData: {
        sort: 0
      },
      loading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    getData: function getData(id) {
      var _this = this;
      this.loading = true;
      (0, _marketing.liveGoodsInfoApi)(id).then(function (res) {
        _this.FormData = res;
        _this.loading = false;
      }).catch(function (res) {
        _this.loading = false;
      });
    },
    // 排序
    handleSort: function handleSort() {
      var _this2 = this;
      (0, _marketing.liveGoodsSortApi)(this.FormData.id, this.FormData.sort).then(function (res) {
        _this2.dialogVisible = false;
        _this2.$emit('getList');
        _this2.$message.success('操作成功');
      });
    }
  }
};